// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';


i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          // common
          "title": "Search Command Builder(β)",
          "description": "The web tool facilitates visually constructing and executing search commands for use on search engines like Google and Bing.",
          "command_list_title": "CommandList",
          "build_area_title": "BuildArea",
          "search": "Search",

          // google
          "google_or_description": "Search for pages that include either of the specified terms \ne.g., keyword OR keyword",
          "google_keyword_description": "Search for pages that include the specified keyword \ne.g., keyword",
          "google_and_description": "Search for pages that include all of the specified terms \ne.g., keyword AND keyword",
          "google_except_description": "Search for pages excluding specified keywords. \ne.g., -keyword",
          "google_exact_description": "Search for pages containing exact matching keywords. \ne.g., \"keyword\"",
          "google_site_description": "Search within a specified website \ne.g., site:example.com",
          "google_link_description": "Search pages containing links to a specified website \n\ne.g., link:example.com",
          "google_filetype_description": "Search for documents of a specified file type \ne.g., filetype:pdf",
          "google_intitle_description": "Search for pages with a specified keyword in the title \ne.g., intitle:keyword",
          "google_inurl_description": "Search for pages with a specified keyword in the URL \ne.g., inurl:keyword",
          "google_intext_description": "Search for pages with a specified keyword in the text \ne.g., intext:keyword",
          "google_cache_description": "Display the latest version of a specified website saved in Google's cache \ne.g., cache:example.com",
          "google_inanchor_description": "Search for pages with a specified keyword in the anchor text \ne.g., inanchor:keyword",
          "google_allintitle_description": "Search for pages with all specified keywords in the title \ne.g., allintitle:keyword1 keyword2",
          "google_allinurl_description": "Search for pages with all specified keywords in the URL \ne.g., allinurl:keyword1 keyword2",
          "google_allintext_description": "Search for pages with all specified keywords in the text \ne.g., allintext:keyword1 keyword2",
          "google_before_description": "Search for information before a specified date \ne.g., before:2023-10-28",
          "google_after_description": "Search for information after a specified date \ne.g., after:2023-10-28",

          // bing
          "bing_keyword_description": "Search for pages with the specified keyword \ne.g., keyword",
          "bing_or_description": "Search for pages containing either of the specified terms \ne.g., keyword OR another_keyword",
          "bing_and_description": "Search for pages that contain all the specified terms \ne.g., keyword AND another_keyword",
          "bing_exact_description": "Search for pages containing an exact phrase \ne.g., \"exact phrase\"",
          "bing_except_description": "Search for pages excluding a certain keyword \ne.g., -keyword",
          "bing_site_description": "Search within a specific site \ne.g., site:example.com",
          "bing_link_description": "Search for pages that link to a specific website \ne.g., link:example.com",
          "bing_filetype_description": "Search for documents of a specified filetype \ne.g., filetype:pdf",
          "bing_intitle_description": "Search for pages with a specified keyword in the title \ne.g., intitle:keyword",
          "bing_inurl_description": "Search for pages with a specified keyword in the URL \ne.g., inurl:keyword",
          "bing_intext_description": "Search for pages with a specified keyword in the text \ne.g., intext:keyword",
          "bing_contains_description": "Search for pages that contain a particular file type \ne.g., contains:example",
          "bing_ip_description": "Search for web pages associated with a specific IP address \ne.g., ip:IP_address",
          "bing_loc_description": "Limit search results to a specific region \ne.g., loc:region_name",
          "bing_language_description": "Search for pages in a specific language \ne.g., language:language_code",
          "bing_feed_description": "Search for pages that contain a feed \ne.g., feed:feed_url",
          "bing_hasfeed_description": "Search for pages that contain an RSS or Atom feed \ne.g., hasfeed:keyword_with_feed",
          "bing_near_description": "Search for results near a certain location \ne.g., near:place_name",

          

          // youtube
          "youtube_keyword_description": "Search for a specified keyword \nExample: keyword",
          "youtube_or_description": "Search for pages that include either of the specified terms \nExample: keyword OR keyword",
          "youtube_except_description": "Search for pages excluding a specified keyword \nExample: -keyword",
          "youtube_allintitle_description": "Search for pages with titles containing all the specified keywords \nExample: allintitle: keyword1 keyword2",
          "youtube_before_description": "Search for information before a specified date \nExample: before:yyyy-mm-dd",
          "youtube_after_description": "Search for information after a specified date \nExample: after:yyyy-mm-dd",

          // amazon
          "amazon_keyword_description": "Display search results matching a keyword \nExample: keyword",
          "amazon_and_description": "Display search results matching all keywords \nExample: keyword1 keyword2",
          "amazon_or_description": "Search for products matching any of the keywords \nExample: keyword1 | keyword2",
          "amazon_amazononly_description": "Narrow down to products sold by Amazon only",
          "amazon_reviewrank_description": "Sort by highest reviews",
          "amazon_-reviewrank_description": "Sort by lowest reviews",
          "amazon_popularity-rank_description": "Sort by popularity",
          "amazon_highprice_description": "Products higher than a specified price",
          "amazon_lowprice_description": "Products cheaper than a specified price",
          "amazon_salesrank_description": "Sort by sales rank",
          "amazon_pctoff_description": "Specify a discount rate",
          "amazon_datedesc_description": "Sort by newest",
          "amazon_dateasc_description": "Sort by oldest",
          "amazon_priceasc_description": "Sort by lowest price",
          "amazon_pricedesc_description": "Sort by highest price",

          // X
          "twitter_from_description": "Search for tweets from a specific user \nExample: from:username",
          "twitter_to_description": "Search for tweets to a specific user \nExample: to:username",
          "twitter_mention_description": "Search for mentions of a specific user \nExample: @username",
          "twitter_hashtag_description": "Search for tweets containing a specific hashtag \nExample: #hashtag",
          "twitter_exact_phrase_description": "Search for tweets containing an exact phrase \nExample: \"exact phrase\"",
          "twitter_exclude_word_description": "Search for tweets excluding a specific word \nExample: -word",
          "twitter_since_description": "Search for tweets since a specified date \nExample: since:yyyy-mm-dd",
          "twitter_until_description": "Search for tweets until a specified date \nExample: until:yyyy-mm-dd",
          "twitter_filter_links_description": "Search for tweets containing links \nExample: filter:links",
          "twitter_filter_images_description": "Search for tweets containing images \nExample: filter:images",
          "twitter_filter_videos_description": "Search for tweets containing videos \nExample: filter:videos",
          "twitter_filter_verified_description": "Search only for tweets from verified users \nExample: filter:verified",
          "twitter_question_description": "Search for tweets containing questions \nExample: ?",
          "twitter_lang_description": "Search for tweets written in a specific language \nExample: lang:ja",

        }
      },
      ja: {
        translation: {
          // 共通
          "title": "検索コマンドビルダー(β)",
          "description": "GoogleやBingなどの検索エンジンで使用する検索コマンドを視覚的に組み立てて実行します。",
          "command_list_title": "コマンド一覧",
          "build_area_title": "実行するコマンド",
          "search": "検索",

          // google
          "google_keyword_description": "指定したキーワードを検索する \n例:キーワード",
          "google_or_description": "指定したどちらかを含むページを検索する \n例:-キーワード OR キーワード",
          "google_and_description": "指定した全てを含むページを検索する \n例:-キーワード AND キーワード",
          "google_except_description": "指定したキーワードを除外したページを検索する \n例:-キーワード",
          "google_exact_description": "完全一致するキーワードを含むページを検索する \n例:\"キーワード\"",
          "google_site_description": "指定したサイト内を検索する \n例: site:example.com",
          "google_link_description": "指定したウェブサイトへのリンクが含まれているページを検索する \n例: link:example.com",
          "google_filetype_description": "指定したファイルタイプのドキュメントを検索する \n例: filetype:pdf",
          "google_intitle_description": "ページのタイトルに指定したキーワードが含まれているものを検索する \n例: intitle:キーワード",
          "google_inurl_description": "URLに指定したキーワードが含まれているページを検索する \n例: inurl:キーワード",
          "google_intext_description": "ページの本文に指定したキーワードが含まれているものを検索する \n例: intext:キーワード",
          "google_cache_description": "Googleのキャッシュに保存されている、指定したウェブサイトの最新版を表示する \n例: cache:example.com",
          "google_inanchor_description": "アンカーテキストに指定したキーワードが含まれるページを検索する \n例: inanchor:キーワード",
          "google_allintitle_description": "ページのタイトルに複数の指定したキーワードがすべて含まれているものを検索する \n例: allintitle:キーワード1 キーワード2",
          "google_allinurl_description": "URLに複数の指定したキーワードがすべて含まれているページを検索する \n例: allinurl:キーワード1 キーワード2",
          "google_allintext_description": "ページの本文に複数の指定したキーワードがすべて含まれているものを検索する \n例: allintext:キーワード1 キーワード2",
          "google_before_description": "指定した日付より前の情報を検索する \n例: before:yyyy-mm-dd",
          "google_after_description": "指定した日付より後の情報を検索する \n例: after:yyyy-mm-dd",

          // bing
          "bing_keyword_description": "指定したキーワードを検索する \n例:キーワード",
          "bing_or_description": "指定したどちらかを含むページを検索する \n例:キーワード OR キーワード",
          "bing_and_description": "指定した全てを含むページを検索する \n例:キーワード AND キーワード",
          "bing_exact_description": "完全一致するキーワードを含むページを検索する \n例:\"キーワード\"",
          "bing_except_description": "指定したキーワードを除外したページを検索する \n例:-キーワード",
          "bing_site_description": "指定したサイト内を検索する \n例: site:example.com",
          "bing_link_description": "指定したウェブサイトへのリンクが含まれているページを検索する \n例: link:example.com",
          "bing_filetype_description": "指定したファイルタイプのドキュメントを検索する \n例: filetype:pdf",
          "bing_intitle_description": "ページのタイトルに指定したキーワードが含まれているものを検索する \n例: intitle:キーワード",
          "bing_inurl_description": "URLに指定したキーワードが含まれているページを検索する \n例: inurl:キーワード",
          "bing_intext_description": "ページの本文に指定したキーワードが含まれているものを検索する \n例: intext:キーワード",
          "bing_contains_description": "特定のファイルを含むページを検索する \n例: contains:例:テキスト",
          "bing_ip_description": "特定のIPアドレスに関連するウェブページを検索する \n例: ip:IPアドレス",
          "bing_loc_description": "特定の地域の結果に限定して検索する \n例: loc:地域名",
          "bing_language_description": "特定の言語のページを検索する \n例: language:言語コード",
          "bing_feed_description": "フィードを含むページを検索する \n例: feed:フィードURL",
          "bing_hasfeed_description": "RSSまたはAtomフィードを含むページを検索する \n例: hasfeed:フィードを含むキーワード",
          "bing_near_description": "特定の場所の近くの結果を検索する \n例: near:場所の名前",

          // youtube
          "youtube_keyword_description": "指定したキーワードを検索する \n例:キーワード",
          "youtube_or_description": "指定したどちらかを含むページを検索する \n例:-キーワード OR キーワード",
          "youtube_except_description": "指定したキーワードを除外したページを検索する \n例:-キーワード",
          "youtube_allintitle_description": "ページのタイトルに複数の指定したキーワードがすべて含まれているものを検索する \n例: allintitle:キーワード1 キーワード2",
          "youtube_before_description": "指定した日付より前の情報を検索する \n例: before:yyyy-mm-dd",
          "youtube_after_description": "指定した日付より後の情報を検索する \n例: after:yyyy-mm-dd",

          // amazon
          "amazon_keyword_description": "キーワードに一致する検索結果を表示 \n例: キーワード",
          "amazon_and_description": "キーワードすべてに一致する検索結果を表示 \n例: キーワード1 キーワード2",
          "amazon_or_description": "キーワードのいずれかに一致した商品の検索 \n例: キーワード1 | キーワード2",
          "amazon_amazononly_description": "Amazonの販売商品だけに絞り込む",
          "amazon_reviewrank_description": "レビューの高い順に並び替える",
          "amazon_-reviewrank_description": "レビューの低い順に並び替える",
          "amazon_popularity-rank_description": "人気順に並び替える",
          "amazon_highprice_description": "指定金額より高い商品",
          "amazon_lowprice_description": "指定金額より安い商品",
          "amazon_salesrank_description": "売れている順に並び替える",
          "amazon_pctoff_description": "値引き率を指定する",
          "amazon_datedesc_description": "新しい順に並び替える",
          "amazon_dateasc_description": "古い順に並び替える",
          "amazon_priceasc_description": "価格が安い順に並び替える",
          "amazon_pricedesc_description": "価格が高い順に並び替える",


          // X
          "twitter_from_description": "特定のユーザーからのツイートを検索する \n例: from:username",
          "twitter_to_description": "特定のユーザー宛のツイートを検索する \n例: to:username",
          "twitter_mention_description": "特定のユーザーへの言及を検索する \n例: @username",
          "twitter_hashtag_description": "特定のハッシュタグが含まれるツイートを検索する \n例: #hashtag",
          "twitter_exact_phrase_description": "正確なフレーズを含むツイートを検索する \n例: \"exact phrase\"",
          "twitter_exclude_word_description": "特定の単語を除外してツイートを検索する \n例: -word",
          "twitter_since_description": "指定された日付以降のツイートを検索する \n例: since:yyyy-mm-dd",
          "twitter_until_description": "指定された日付までのツイートを検索する \n例: until:yyyy-mm-dd",
          "twitter_filter_links_description": "リンクを含むツイートを検索する \n例: filter:links",
          "twitter_filter_images_description": "画像を含むツイートを検索する \n例: filter:images",
          "twitter_filter_videos_description": "ビデオを含むツイートを検索する \n例: filter:videos",
          "twitter_filter_verified_description": "認証済みユーザーのツイートのみを検索する \n例: filter:verified",
          "twitter_question_description": "質問を含むツイートを検索する \n例: ?",
          "twitter_lang_description": "特定の言語で書かれたツイートを検索する \n例: lang:ja",

        }
      }

    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
